import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate, spring } from "remotion";
import React from "react";

// VFX: Morphing Words
// Category: text-animations · Tags: morphing, words, transform, text, animated
export default function TextMorphingWordsTransform800Ms() {
  const frame = useCurrentFrame();
  const { fps, durationInFrames } = useVideoConfig();
  const words = ["IDEIA", "FORMA", "VIDA"];
  const each = durationInFrames / words.length;
  const idx = Math.min(Math.floor(frame / each), words.length - 1);
  const local = frame - idx * each;
  const enter = spring({ frame: local, fps, config: { damping: 14, mass: 0.5 } });
  const exit = interpolate(local, [each - 8, each], [1, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const blur = interpolate(enter, [0, 1], [20, 0]) + interpolate(exit, [0, 1], [16, 0]);
  return (
    <AbsoluteFill style={{ background: "#0a0e1a", justifyContent: "center", alignItems: "center" }}>
      <h1 style={{
        fontFamily: "Inter, system-ui, sans-serif",
        fontSize: 240, fontWeight: 900, letterSpacing: -8,
        color: "#f8fafc", margin: 0,
        opacity: enter * exit,
        filter: `blur(${blur}px)`,
        transform: `scale(${interpolate(enter * exit, [0, 1], [0.7, 1])}) skewX(${interpolate(local, [0, each / 2, each], [-6, 0, 6])}deg)`,
        textShadow: "0 0 60px rgba(168,85,247,0.6)",
      }}>
        {words[idx]}
      </h1>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
